import React, { useCallback } from 'react';

import { AppointmentRegistrationModal as AppointmentRegistrationModalView } from './appointment-registration-modal';
import { AppointmentRegistrationModalProps } from './appointment-registration-modal.models';

export const AppointmentRegistrationModal = ({
  updateAppointments, ecpService, onRegistrationComplete, goNextButtonTestIdsByStep, onClose, ...props
}: AppointmentRegistrationModalProps): JSX.Element => {

  const handleRegistrationComplete = useCallback((): void => {
    onClose?.();
    onRegistrationComplete();
  }, [onClose, onRegistrationComplete]);

  return (
    <AppointmentRegistrationModalView
      {...props}
      updateAppointments={updateAppointments}
      ecpService={ecpService}
      onRegistrationComplete={handleRegistrationComplete}
      goNextButtonTestIdsByStep={goNextButtonTestIdsByStep}
      onClose={onClose}
    />
  );
};
